export const LinksFixo = [{
  name: 'Ajuda',
  href: 'https://www.olx.com.br/faq.htm',
  clickEvent: 'help'
}, {
  name: 'Dicas de segurança',
  href: 'https://seguranca.olx.com.br/?ic=prod-mkt&local=footer_web&campaign=hubseguranca&message=footer_web',
  clickEvent: 'security_tips'
}, {
  name: 'Termos de uso',
  href: 'https://www.olx.com.br/copyright.htm',
  clickEvent: 'terms'
}, {
  name: 'Política de privacidade',
  href: 'https://ajuda.olx.com.br/s/article/politica-de-privacidade',
  clickEvent: 'privacy'
}, {
  name: 'Propriedade intelectual',
  href: 'https://ajuda.olx.com.br/s/article/protecao-a-propriedade',
  clickEvent: 'intellectual_property'
}, {
  name: 'Mapa do site',
  href: 'https://www.olx.com.br/mapa-do-site',
  clickEvent: 'site_map'
}];
export const LinksOldFooter = [{
  name: 'Sobre a OLX',
  href: 'https://ajuda.olx.com.br/s/tema/sobre-a-olx',
  clickEvent: ''
}, {
  name: 'Vender na OLX',
  href: 'https://compra-segura.olx.com.br/compra-segura',
  clickEvent: ''
}, {
  name: 'Plano profissional',
  href: 'https://planoprofissional.olx.com.br/',
  clickEvent: 'my_plan'
}];